import axios from 'axios'
import { AuthStorageInstance } from 'services/Storage/AuthStorage'
import { getEnvConfig } from 'utils/getEnvConfig'
import { API_RESPONSE_TYPE, IApiResponse } from '../../constants'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const GDRIVE_TOKEN_ENDPOINT = '/gdrive/'
const GDRIVE_AUTH_URL_PROXY_ENDPOINT = '/tauri/api/gdrive/auth-url'

const DRIVE_ABOUT_URL = 'https://www.googleapis.com/drive/v3/about'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = getEnvConfig('WEB_BASE_URL') || ''

const api = new ApiService(endpoint, headers)
api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

const proxyApi = new ApiService('', headers)
proxyApi.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
proxyApi.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
proxyApi.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export interface IGoogleDriveToken {
  access_token: string
  expiry: string
}

export interface IGoogleDriveAbout {
  user: {
    displayName?: string
    emailAddress: string
    photoLink?: string
  }
  storageQuota: {
    limit?: string
    usage: string
  }
}

export const getGoogleDriveAccessToken = (): Promise<IApiResponse<IGoogleDriveToken>> => {
  return api.getRequest(GDRIVE_TOKEN_ENDPOINT, {})
}

export const requestGoogleDriveAuthUrl = async (): Promise<IApiResponse<string>> => {
  const businessId = AuthStorageInstance.getCurrentBusinessId() || ''
  const response = await proxyApi.postRequest<{ businessId: string }>(
    GDRIVE_AUTH_URL_PROXY_ENDPOINT,
    { businessId }
  )
  if (response.type === API_RESPONSE_TYPE.SUCCESS && response.data?.url) {
    return { data: response.data.url, type: API_RESPONSE_TYPE.SUCCESS }
  }
  return { data: '', type: API_RESPONSE_TYPE.FAILURE }
}

export const fetchGoogleDriveAbout = async (
  accessToken: string
): Promise<IApiResponse<IGoogleDriveAbout>> => {
  try {
    const response = await axios.get(DRIVE_ABOUT_URL, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: { fields: 'user,storageQuota' }
    })
    return { data: response.data, type: API_RESPONSE_TYPE.SUCCESS }
  } catch (error) {
    console.error('GDRIVE ABOUT ERROR =>', error)
    return { data: error, type: API_RESPONSE_TYPE.FAILURE }
  }
}

export const GoogleDriveApi = {
  getGoogleDriveAccessToken,
  requestGoogleDriveAuthUrl,
  fetchGoogleDriveAbout
}
